import { useState, useCallback } from 'react';
import { rasService } from '../services/rasService';
import { AppLogParams, AppLogResponse } from '../types/api';

export const useAppLogs = () => {
  const [logs, setLogs] = useState<AppLogResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const searchLogs = useCallback(async (params: AppLogParams) => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await rasService.queryAppLogs(params);
      setLogs(result);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch app logs';
      setError(errorMessage);
      setLogs(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const clearLogs = useCallback(() => {
    setLogs(null);
    setError(null);
  }, []);

  return {
    logs,
    loading,
    error,
    searchLogs,
    clearLogs
  };
};